import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { ReasonService } from "../report-services/reason.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./hallpassreport.component.html",
})
export class HallPassReportComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private reasonService: ReasonService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		ReasonID: 0,
		OrderByID: "Duration",
		ImageLogo: "",
		ShowDetailID: "Yes",
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	ReasonList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 348;

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	OrderByList = [
		//Insert Custom List Items Here
		{
			OrderByID: "Duration",
			OrderByName: "Duration",
		},
		{
			OrderByID: "Date",
			OrderByName: "Date",
		},
		{
			OrderByID: "Name",
			OrderByName: "Name",
		},
		{
			OrderByID: "Reason",
			OrderByName: "Reason",
		},
		{
			OrderByID: "Start Time",
			OrderByName: "Start Time",
		},
	];

	ShowDetailList = [
		//Insert Custom List Items Here
		{
			ShowDetailID: "Yes",
			ShowDetailName: "Yes",
		},
		{
			ShowDetailID: "No",
			ShowDetailName: "No",
		},
	];

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadReasonList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadReasonList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(348);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadReasonList() {
		this.report.ReasonID = 0;
		var result = this.reasonService.loadReasonList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ReasonList = response;

				if (this.ReasonList.length > 1) {
					// this.ReasonList.unshift({
					//     ReasonID: 0,
					//     ReasonDesc: "All Reasons"
					// })
					this.report.ReasonID = this.ReasonList[0].ReasonID;
				} else {
					this.report.ReasonID = this.ReasonList[0].ReasonID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.ReasonID) {
		// 	this.errorMessage = "Select the Reason"
		// 	return;
		// }

		// if (!this.report.OrderByID) {
		// 	this.errorMessage = "Select the OrderBy"
		// 	return;
		// }

		// if (!this.report.ShowDetailID) {
		// 	this.errorMessage = "Select the ShowDetail"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 348;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: ReasonID
		strParam += "," + this.report.ReasonID + "|ReasonID";

		//Parameter 5: OrderBy
		strParam += "," + this.report.OrderByID + "|OrderBy";

		//Parameter 6: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		//Parameter 7: ShowDetail
		strParam += "," + this.report.ShowDetailID + "|ShowDetail";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
